import { Tooltip, TooltipTrigger } from '@/components/ui/tooltip'
import { cn } from '@/lib/utils'
import ProjectTaskMenu from '@/frontend/features/Fde/ProjectTaskMenu'
import { TaskStatusIcon, taskStatusTone } from '@/frontend/features/Fde/projectTaskPresentation'
import ProjectTaskTooltipContent from '@/frontend/features/Fde/ProjectTaskTooltipContent'
import type { TaskSurfaceProps } from '@/frontend/features/Fde/ProjectTaskCanvas'
import type { ProjectTask } from '@/frontend/features/Fde/types'

interface Props extends Omit<TaskSurfaceProps, 'tasks' | 'overdueIds' | 'onSelect'> {
  task: ProjectTask
  overdue: boolean
  onSelect: () => void
}

export default function ProjectTaskCalendarEntry(props: Props) {
  const { task, copy, onSelect, overdue } = props
  const words = copy.management
  return (
    <Tooltip delayDuration={250}>
      <ProjectTaskMenu {...props}>
        <TooltipTrigger asChild>
          <button
            type="button"
            aria-label={task.title}
            aria-description={`${words.calendar_color_hint} ${words.statuses[task.status]}`}
            onClick={onSelect}
            className={cn(
              'flex w-full items-start gap-1 rounded-md px-1.5 py-1.5 text-left text-[10px] leading-4 focus-visible:outline focus-visible:outline-2 focus-visible:outline-ring',
              taskStatusTone[task.status],
            )}
          >
            <TaskStatusIcon status={task.status} className="mt-0.5 size-3 shrink-0" />
            <span className="line-clamp-2">
              <span className="opacity-70">{task.identifier}</span> {task.title}
            </span>
          </button>
        </TooltipTrigger>
      </ProjectTaskMenu>
      <ProjectTaskTooltipContent task={task} copy={copy} overdue={overdue} />
    </Tooltip>
  )
}
